module.exports = __webpack_public_path__ + "static/media/ProximaNova-Light.04d5b9ed.woff";